'use client'

import { useGetPromotionsBar } from './hooks/useGetPromotionsBar'
import { PromotionsBar } from './PromotionsBar'

export const PromotionsBarPagesRouter = () => {
  const { content, isVisible } = useGetPromotionsBar({
    isBusinessPage: false,
  })

  return <PromotionsBar content={content} isVisible={isVisible} />
}
